import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import type { BrandThemeIcon } from '@jotta/types/Brand'
import { t } from '@lingui/macro'
import clsx from 'clsx'
import type { PropsWithChildren, ReactNode } from 'react'
import { useEffect, useState } from 'react'
import { FormattedContent } from '../FormattedContent/FormattedContent'
import SvgCloudError from '@jotta/ui/SvgCloudError'
import { useLocation } from 'react-router-dom'

export function BaseErrorPage({
  title = t`An error occured!`,
  reportError,
  icon = SvgCloudError,
  children,
  className,
}: PropsWithChildren<{
  reportError: Error | undefined
  title?: ReactNode
  icon?: BrandThemeIcon
  className?: string
}>) {
  useEffect(() => reportError && window.reportError(reportError), [reportError])
  const currentLocation = useLocation()
  const [originalLocation] = useState(currentLocation)
  useEffect(() => {
    if (currentLocation != originalLocation) {
      // forcefully reload if navigating while displaying an error page
      window.location.reload()
    }
  }, [currentLocation, originalLocation])

  return (
    <div
      className={clsx(
        'mx-auto grid max-w-4xl grid-cols-1 justify-items-center gap-8 break-words p-8 md:grid-cols-2',
        className,
      )}
      style={{
        overflowWrap: 'anywhere', // https://github.com/tailwindlabs/tailwindcss/discussions/12127
      }}
    >
      <PlainBrandIcon icon={icon} className="max-w-64 md:justify-self-end" />
      <FormattedContent
        variant="formats.errorPage"
        className="md:justify-self-start"
      >
        <header className="title-sm pb-4">{title}</header>
        {children}
      </FormattedContent>
    </div>
  )
}
